import { useEffect, useRef } from 'react';
import quizImageFallback from './quiz_image.png';
import quizImage1 from './1.png';
import quizImage2 from './2.png';
import quizImage3 from './3.png';
import quizImage4 from './4.png';
import quizImage5 from './5.png';
import quizImage6 from './6.png';
import quizImage7 from './7.png';
import quizImage8 from './8.png';
import quizImage9 from './9.png';
import quizImage10 from './10.png';
import quizImage11 from './11.png';
import quizImage12 from './12.png';
import quizImage13 from './13.png';
import quizImage14 from './14.png';
import quizImage15 from './15.png';
import quizImage16 from './16.png';
import quizImage17 from './17.png';
import quizImage18 from './18.png';
import quizImage19 from './19.png';
import quizImage20 from './20.png';
import quizImage21 from './21.png';
import quizImage22 from './22.png';
import quizImage23 from './23.png';
import quizImage24 from './24.png';
import quizImage25 from './25.png';
import quizImage26 from './26.png';
import quizImage27 from './27.png';
import quizImage28 from './28.png';
import quizImage29 from './29.png';
import quizImage30 from './30.png';
import quizImage31 from './31.png';
import quizImage32 from './32.png';
import quizImage33 from './33.png';
import quizImage34 from './34.png';
import quizImage35 from './35.png';
import quizImage36 from './36.png';
import quizImage37 from './37.png';
import quizImage38 from './38.png';
import quizImage39 from './39.png';
import quizImage40 from './40.png';
import quizImage41 from './41.png';
import quizImage42 from './42.png';
import quizImage43 from './43.png';
import quizImage44 from './44.png';
import quizImage45 from './45.png';
import quizImage46 from './46.png';
import quizImage47 from './47.png';
import quizImage48 from './48.png';
import './QuizImage.css';

const QUIZ_IMAGES_BY_NUMBER: ReadonlyMap<number, string> = new Map([
  [1, quizImage1],
  [2, quizImage2],
  [3, quizImage3],
  [4, quizImage4],
  [5, quizImage5],
  [6, quizImage6],
  [7, quizImage7],
  [8, quizImage8],
  [9, quizImage9],
  [10, quizImage10],
  [11, quizImage11],
  [12, quizImage12],
  [13, quizImage13],
  [14, quizImage14],
  [15, quizImage15],
  [16, quizImage16],
  [17, quizImage17],
  [18, quizImage18],
  [19, quizImage19],
  [20, quizImage20],
  [21, quizImage21],
  [22, quizImage22],
  [23, quizImage23],
  [24, quizImage24],
  [25, quizImage25],
  [26, quizImage26],
  [27, quizImage27],
  [28, quizImage28],
  [29, quizImage29],
  [30, quizImage30],
  [31, quizImage31],
  [32, quizImage32],
  [33, quizImage33],
  [34, quizImage34],
  [35, quizImage35],
  [36, quizImage36],
  [37, quizImage37],
  [38, quizImage38],
  [39, quizImage39],
  [40, quizImage40],
  [41, quizImage41],
  [42, quizImage42],
  [43, quizImage43],
  [44, quizImage44],
  [45, quizImage45],
  [46, quizImage46],
  [47, quizImage47],
  [48, quizImage48],
]);

function imageSrcForQuestionId(questionId: string | undefined): string {
  if (questionId == null) {
    return quizImageFallback;
  }
  const match = /^quiz_(\d+)$/.exec(questionId);
  if (match == null) {
    return quizImageFallback;
  }
  return QUIZ_IMAGES_BY_NUMBER.get(Number(match[1])) ?? quizImageFallback;
}

export type QuizImageProps = {
  questionId?: string;
  ready?: boolean;
  onReady?: () => void;
};

/** Figma image 171 (161:23931) — quiz illustration with white frame. */
export function QuizImage({ questionId, ready = false, onReady }: QuizImageProps) {
  const src = imageSrcForQuestionId(questionId);
  const imgRef = useRef<HTMLImageElement>(null);
  const onReadyRef = useRef(onReady);
  onReadyRef.current = onReady;

  useEffect(() => {
    const img = imgRef.current;
    if (img == null) {
      return;
    }

    let cancelled = false;

    const notify = () => {
      if (!cancelled) {
        onReadyRef.current?.();
      }
    };

    const waitDecoded = () => {
      if (typeof img.decode === 'function') {
        void img.decode().then(notify, notify);
        return;
      }
      notify();
    };

    if (img.complete && img.naturalWidth > 0) {
      waitDecoded();
    } else {
      img.addEventListener('load', waitDecoded);
      img.addEventListener('error', notify);
    }

    return () => {
      cancelled = true;
      img.removeEventListener('load', waitDecoded);
      img.removeEventListener('error', notify);
    };
  }, [src]);

  return (
    <img
      ref={imgRef}
      className={['quiz-image', ready ? 'quiz-content-enter' : 'quiz-image--pending']
        .filter(Boolean)
        .join(' ')}
      src={src}
      alt=""
      draggable={false}
      decoding="async"
      fetchPriority="high"
    />
  );
}
